import { loadCacheFromLocalStorage, toRestoreGridPage } from '../../../../helpers/localStorage';
import { INITIAL_SORT, DEFAULT_COLUMNS, INITIAL_FILTERS, INITIAL_PAGE } from '../constants';

// eslint-disable-next-line import/prefer-default-export
export const getInitialData = (cacheKey) => {
  const cache = loadCacheFromLocalStorage(cacheKey);
  if (cacheIsValid(cache, cacheKey)) {
    return {
      ...cache,
      filters: withNewFilters(cache.filters),
      loading: true,
      page: toRestoreGridPage() && cache.page ? cache.page : INITIAL_PAGE
    };
  }

  return {
    page: INITIAL_PAGE,
    sort: INITIAL_SORT,
    filters: INITIAL_FILTERS,
    columns: DEFAULT_COLUMNS,
    loading: true
  };
};

// A cached grid is restored wholesale, so a filter added after a user's cache was written would
// never appear for them -- they would have to hit Reset Cache, losing their column and sort
// preferences, to discover it. Backfill only the keys the cache is missing; a cached value always
// wins, so this never overrides what the user chose.
const withNewFilters = (cached) => ({
  ...cached,
  values: { ...INITIAL_FILTERS.values, ...cached.values },
  active: { ...INITIAL_FILTERS.active, ...cached.active },
  operators: { ...INITIAL_FILTERS.operators, ...cached.operators }
});

const cacheIsValid = (cache, cacheKey) => {
  if (!cache) return false;

  if (
    cache.filters &&
    cache.filters.values &&
    cache.filters.active &&
    cache.filters.operators &&
    cache.sort &&
    typeof cache.columns[0] === 'string'
  )
    return true;

  localStorage.removeItem(cacheKey);
  return false;
};
